export default __webpack_public_path__ + "0a3b18b232c0eb0fd4f366351a4a88ab.jpg";